import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

export const Portal = ({ containerEl, children }) => (containerEl ? ReactDOM.createPortal(children, containerEl) : null)

Portal.propTypes = {
  containerEl: PropTypes.any,
  children: PropTypes.node.isRequired,
}
